import React from 'react'
import MegaMenu from '../../lib/mega-menu'

const MenuHeader = [
    {mega: true}, 
    {link: '/', label: 'بیت'},
    {link: '/about-us', label: 'معلومات عنا'},
    {link: '/content-us', label: 'اتصل بنا'},

]

export default MenuHeader
